export default "__VITE_ASSET__ANHY9mpd__"